const styles = (theme) => ({
  paperContainer: {
    display: "flex",

    p: 2,
    flexDirection: "column",
    borderRadius: "16px",
    margin: "10px",
  },
  boxContainer: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyContent: "space-between",
  },
  containerIcon: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
  },
  icon: {
    fontSize: "20px",
    color: theme.palette.white.main,
  },
  containerValue: {
    display: "100%",
    display: "flex",
    gap: 1,
    alignItems: "center",
  },
  value: {
    fontWeight: "bold",
    fontSize: "25px",
    marginLeft: "10px",
  },
  descricao: {
    color: theme.palette.white.main,
    fontSize: "12px",
    margin: "10px 0 0 0",
    opacity: 0.7,
  },
});

export default styles;
